<template>
    <Head title="Employee Management"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template #start>
                        <Button
                                label="Print Selected Candidate"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportDetailToPdf"
                                :disabled="
                                    !selectedModels || !selectedModels.length || selectedModels.length > 1
                                "
                            />
                    </template>
                    <template #end>
                        <Button
                                label="Export To Excel"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportToExcel"
                            />
                        <Button
                                label="Print Summary"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportSummaryToPdf"
                            />
                        <Button
                                label="Print Salary Setup"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportSalarySetupToPdf"
                            />
                        <Button
                                label="Print BPJS Membership"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                :loading="isExporting"
                                @click="exportBpjsMembershipToPdf"
                            />
                    </template>
                </Toolbar>
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25, 50]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    :selectAll="selectAll"
                    @select-all-change="onSelectAllChange"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Employee</h5>

                            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                <span class="block mt-2 mr-2 md:mt-0 p-input-icon-left">
                                    <i class="pi pi-search" />
                                    <Dropdown
                                        v-model="placement"
                                        :options="placements"
                                        optionLabel="name"
                                        optionValue="id"
                                        placeholder="Select Placement"
                                        showClear
                                        editable
                                        @change="filterByPlacement"
                                    />
                                </span>
                                <span class="block mt-2 md:mt-0 p-input-icon-left">
                                    <i class="pi pi-search" />
                                    <InputText
                                        @change="onFilter($event)"
                                        v-model="searchText"
                                        placeholder="Search..."
                                    />
                                </span>
                            </div>

                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="nik"
                        header="NIK"
                        :sortable="true"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">NIK</span>
                            {{ slotProps.data.nik }}
                        </template>
                    </Column>
                    <Column
                        field="name"
                        header="Name"
                        :sortable="true"
                        headerStyle="width:30%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.name }}
                        </template>
                    </Column>
                    <Column
                        field="placement_id"
                        header="Placement"
                        :sortable="true"
                        headerStyle="width:40%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Placement</span>
                            {{ slotProps.data.placement }}
                        </template>
                    </Column>
                    <Column
                        field="position_id"
                        header="Position"
                        :sortable="true"
                        headerStyle="width:40%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.position }}
                        </template>
                    </Column>
                    <Column
                        headerStyle="width:90%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <Button
                                v-tooltip.top="'Detail Employee'"
                                icon="pi pi-eye"
                                class="mr-2"
                                @click="editModel(slotProps.data.id)"
                            />
                            <Button
                                v-if="slotProps.data.user_account_id"
                                v-tooltip.top="'Jadwal Kerja'"
                                icon="pi pi-list"
                                class="p-button-info mr-2"
                                @click="this.$inertia.get(this.route('mapping-shifts', slotProps.data.user_account_id))"
                            />
                            <Button
                                v-if="slotProps.data.user_account_id"
                                v-tooltip.bottom="'Manage Pengajuan Lembur'"
                                icon="pi pi-ticket"
                                class="p-button-help mr-2"
                                @click="this.$inertia.get(this.route('overtime', slotProps.data.user_account_id))"
                            />
                            <Button
                                v-tooltip.bottom="'Pecat Karyawan'"
                                icon="pi pi-trash"
                                class="p-button-warning mt-2"
                                @click="confirmDeleteModel(slotProps.data)"
                            />
                        </template>
                    </Column>
                </DataTable>
                <Dialog
                    v-model:visible="deleteModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete
                            <b>{{ model.name }}</b
                            >?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteModel"
                        />
                    </template>
                </Dialog>
                <Dialog
                    v-model:visible="deleteModelsDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete the selected
                            models?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelsDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteSelectedModels"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Checkbox from "primevue/checkbox";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Message from "primevue/message";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import FileUpload from "primevue/fileupload";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";
import Dialog from "primevue/dialog";
import DatatableService from "../../Services/DatatableService";
import SplitButton from "primevue/splitbutton";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Checkbox,
        Button,
        InputText,
        Password,
        Message,
        Toolbar,
        Toast,
        FileUpload,
        DataTable,
        Column,
        InputNumber,
        Dropdown,
        RadioButton,
        Dialog,
        SplitButton,
    },
    data() {
        return {
            searchFilter: "",
            filters: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            lazyParams: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            assessmentResults: {},
            typeTests: [
                {testID: 1, testDate: "2022-09-12", score: 100, category:'E'},
                {testID: 2, testDate: "2022-09-13", score: 90, category:'E'},
                {testID: 3, testDate: "2022-09-14", score: 50, category:'E'},
                {testID: 4, testDate: "2022-09-15", score: 20, category:'E'},
                {testID: 5, testDate: "2022-09-16", score: 53, category:'E'},
            ],
            optionValues: [
                {name: 'Adminitrasi', code: 'administrasi'},
                {name: 'Psikotest/Tertulis', code: 'psikotest'},
                {name: 'Wawancara Internal', code: 'wawancara-internal'},
                {name: 'Wawancara External', code: 'wawancara-external'},
                {name: 'Medical Checkup', code: 'mcu'},
            ],
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            models: null,
            selectionTestDialog: false,
            deleteModelDialog: false,
            deleteModelsDialog: false,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            isExporting: false,
            placements: [],
            placement: '',
            searchText: '',
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };

        if(localStorage.getItem('lazyParams')){
            this.lazyParams = JSON.parse(localStorage.getItem('lazyParams'));
            this.placement = this.lazyParams.filters.global.value;
            this.searchText = this.lazyParams.filters.search.value;
        }

        this.loadLazyData();
    },
    computed: {
        totalSummaries() {
            let totalSummary = this.typeTests.reduce((total, item) => parseInt(item.grade) + total, 0);
            return totalSummary
        },
    },
    methods: {
        changeValue(index, score) {
            this.typeTests[index].category = 'A';
            let status = '';


            if(score >= 50 && score <= 100){
                status = "pass";
            }
            else{
                $status = 'fail';
            }
        },
        loadLazyData() {
            this.loading = true;

            this.datatableService
                .getData(`${this.$page.props.appUrl}api/employees/datatable`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
            axios
            .get(`${this.$page.props.appUrl}api/placement-units`)
            .then((data) => {
                this.placements = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
        },
        onSelectAllChange(event) {
            const selectAll = event.checked;
            if (selectAll) {
                this.datatableService.getData(this.route("applicants.index"),this.lazyParams).then((data) => {
                    this.selectAll = true;
                    this.selectedModels = data.data;
                });
            } else {
                this.selectAll = false;
                this.selectedModels = [];
            }
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams.first = event.first;
            this.lazyParams.page = event.page;
            this.lazyParams.pageCount = event.pageCount;
            this.lazyParams.rows = event.rows;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField;
            this.lazyParams.sortOrder = event.sortOrder;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onFilter(event) {
            this.lazyParams.filters['search'] = { field: 'name', value: this.searchText };
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        hideDialog() {
            this.selectionTestDialog = false;
        },
        editModel(id){
            this.$inertia.get(this.route('employee-views.edit', [id]));
        },
        confirmDeleteModel(model) {
            this.model = model;
            this.deleteModelDialog = true;
        },
        deleteModel() {
            axios
                .delete("api/employees/" + this.model.id)
                .then((response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Employee Deleted",
                        life: 3000,
                    });
                    this.deleteModelDialog = false;
                    this.model = {};
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Employee not deleted",
                        life: 3000,
                    });
                });
        },
        exportSummaryToPdf(){
            this.isExporting = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + 'api/employees/export',
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-Summary.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportSalarySetupToPdf(){
            this.isExporting = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/employees/salary-setup-export`,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-Salary-Setup.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportBpjsMembershipToPdf(){
            this.isExporting = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/employees/bpjs-membership`,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-BPJS-Membership.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportDetailToPdf(){
            this.isExporting = true;
            const rawObject = {...this.selectedModels[0]};
            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/employees/${rawObject.id}/export`,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-Detail.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportToExcel(){
            this.isExporting = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + 'api/employees/export/excel',
                responseType: 'blob',
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Employee-All.xlsx');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting To Excel, Contact Developer !",
                    life: 3000,
                });
            });
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                search: { field: 'name', value: null },
            };
        },
        filterByPlacement(){
            this.lazyParams.filters['global'] = { value: this.placement, matchMode: FilterMatchMode.EQUALS, field: 'placement_id' };
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
